import React, { useState } from "react";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@/components/Modal";
import { useTranslation } from "@/langs/useTranslation";
import { DeviceNamingMerchantsDatatable } from "@/helpers/DeviceNamingMerchantsDatatable";
import { IconTitleDot } from "@/components/Icon";
import SearchInput from "@/components/SearchInput";
import { Rule } from "@/helpers/DeviceNamingDatatable";
import { OSTypeChip } from "@/components/FormFields/OSType";

const useStyles = makeStyles(theme => ({
  title: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    marginBottom: theme.spacing(2)
  },
  dot: {
    fontSize: "1.25rem",
    marginRight: theme.spacing(1)
  }
}));

function ViewMerchantsModal({ open, onClose, row }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const [keyword, setKeyword] = useState("");

  return (
    <Modal
      title={t({ defaultMessage: "套用门店列表" })}
      width={650}
      open={open}
      onClose={onClose}
      onConfirm={onClose}
      footer={null}
    >
      {row ? (
        <>
          <Box className={classes.title}>
            <IconTitleDot className={classes.dot} />
            <Typography variant="body2" color="textSecondary">
              {t({ defaultMessage: "命名规则" })}：
            </Typography>
            <Typography variant="body2">
              <Rule rules={row.rules} delimiter={row.delimiter} />
            </Typography>
          </Box>
          <Box className={classes.title}>
            <IconTitleDot className={classes.dot} />
            <Typography variant="body2" color="textSecondary">
              {t({ defaultMessage: "OS类型" })}：
            </Typography>
            <Typography variant="body2">
              <OSTypeChip type={row.osType} />
            </Typography>
          </Box>
          <SearchInput
            icon={null}
            placeholder={t({ defaultMessage: "搜索门店名称" })}
            style={{ marginBottom: 16 }}
            onChange={e => setKeyword(e.target.value)}
          />
          <DeviceNamingMerchantsDatatable id={row.id} keyword={keyword} />
        </>
      ) : null}
    </Modal>
  );
}

export default ViewMerchantsModal;
